"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _propTypes = require("prop-types");

var _copyToClipboard = _interopRequireDefault(require("copy-to-clipboard"));

var _Icons = require("../Icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var LinkBox = function LinkBox(_ref) {
  var children = _ref.children,
      url = _ref.url,
      onClick = _ref.onClick,
      className = _ref.className,
      otherProps = _objectWithoutProperties(_ref, ["children", "url", "onClick", "className"]);

  /**
   * Default click handler which copies the given URL to the user's clipboard.
   */
  var handleClick = function handleClick() {
    (0, _copyToClipboard.default)(url);
  };

  return /*#__PURE__*/_react.default.createElement(StyledLinkBox, _extends({
    onClick: onClick ? onClick : function (e) {
      handleClick(e);
    },
    className: className
  }, otherProps), /*#__PURE__*/_react.default.createElement(UrlBox, null, /*#__PURE__*/_react.default.createElement(_Icons.IconWebWorldFilled, {
    size: 22,
    color: "#8990A3"
  }), url), children ? /*#__PURE__*/_react.default.createElement(InfoBox, null, children) : null);
};

var StyledLinkBox = _styledComponents.default.div.withConfig({
  displayName: "StyledLinkBox"
})(["display:flex;flex-flow:column;justify-content:flex-start;align-items:flex-start;width:100%;max-width:100rem;border-radius:0.5rem;background-color:white;box-shadow:0 0 1px rgba(0,0,0,0.04),0 2px 6px rgba(0,0,0,0.04),0 10px 20px rgba(0,0,0,0.04);border:1px solid #f0f1f3;cursor:pointer;transition:box-shadow 0.2s ease-in-out;&:hover{box-shadow:0 0 1px rgba(0,0,0,0.04),0 2px 6px rgba(0,0,0,0.04),0 16px 24px rgba(0,0,0,0.06);}"]);

var UrlBox = _styledComponents.default.div.withConfig({
  displayName: "UrlBox"
})(["padding:1.2rem;background-color:#f0f1f3;width:100%;border-radius:5px 5px 0 0;display:flex;justify-content:flex-start;align-items:center;font-family:", ";font-size:1.4rem;line-height:120%;color:#222;> svg{margin-right:0.8rem;}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.font;
});

var InfoBox = _styledComponents.default.div.withConfig({
  displayName: "InfoBox"
})(["border-radius:0 0 5px 5px;padding:1.2rem;"]);

LinkBox.propTypes = {
  /** Pass elements to be displayed in the bottom half of the element. */
  children: _propTypes.node,

  /** URL to be displayed inside the element. */
  url: _propTypes.string.isRequired,

  /** If onClick is passed, the default onClick will be overwritten (default onClick copies the URL to clipboard). */
  onClick: _propTypes.func,

  /** Extra classname to be passed to the element. */
  className: _propTypes.string,

  /** Extra props to be passed to the element. */
  otherProps: _propTypes.object
};
var _default = LinkBox;
exports.default = _default;